<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            {
              component: 'h3',
              innerText: 'Osoby'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['name']),
                fields: [
                  new fields.Input({
                    label: 'Imię i nazwisko',
                    modelPath: [this, 'form', 'items', i, 'name'],
                    required: true
                  }),
                  new fields.Input({
                    label: 'Firma',
                    modelPath: [this, 'form', 'items', i, 'company'],
                    required: true
                  }),
                  new fields.Image({
                    label: 'Zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'image'],
                    required: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
